import React, { useContext, useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomToast from "../CommonComponents/CustomToast";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import LK_Add from "../../images/LK_Add";
import LK_Delete from "../../images/LK_Delete";
import CustomTooltip from "../CommonComponents/CustomTooltip";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import Divider from "@mui/material/Divider";
import LK_Edit from "../../images/LK_Edit";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import {
  getdevicelist,
  getFrequencyAndFunctionList,
  saveStorageGroup,
  getStorageGroups,
  deleteStorageGroup,
} from "../../Restclient/datacollection";
import LK_Close from "../../images/LK_Close";
import LK_Search from "../../images/LK_Search";

function TableRow(props) {
  const { theme } = useContext(ThemeContext);

  function handleEdit(e) {
    props.handleEdit(e.currentTarget.id);
  }

  function handleCheck(selected, e) {
    props.handleCheck(selected, e);
  }

  function handlename(name) {
    const newname = name.substring(1);
    return newname;
  }

  function handleFrequencyName(frequency) {
    let f = "";
    const freq = props.freq.filter((item) => item.AggFrequency === frequency);
    if (freq.length > 0) {
      f = freq[0].FrequencyName;
    }
    return f;
  }

  function handleStorageFrequency(data) {
    if (data.length === 0) {
      return "-";
    } else {
      const firstFreq = handleFrequencyName(data[0].Frequency);
      if (data.length !== 1) {
        const lastFreq = handleFrequencyName(data[data.length - 1].Frequency);
        return `${firstFreq}` + " - " + `${lastFreq}`;
      } else {
        return firstFreq;
      }
    }
  }

  return (
    <>
      {props.data.map((data, index) => (
        <>
          <Box
            sx={{
              height: "auto",
              width: "100%",
              backgroundColor: "none",
              boxSizing: "border-box",
              alignContent: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {props.columns.map((column, cindex) => (
              <Box
                sx={{
                  height: "100%",
                  width: column.width ? column.width : "auto",
                  backgroundColor: "none",
                  boxSizing: "border-box",
                  padding: "8px",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {cindex === 0 ? (
                  <>
                    <Box
                      sx={{
                        height: "100%",
                        boxSizing: "border-box",
                        padding: "8px",
                        paddingLeft: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CustomCheckbox
                        id={data.id}
                        checked={
                          props.checkList.includes(data.id) ? true : false
                        }
                        disabled={
                          (props.disabled === 99 && props.disabled === 1) ||
                          data["groupName"].charAt(0) === "_"
                            ? true
                            : false
                        }
                        onChange={handleCheck}
                        width={15}
                        height={15}
                      />
                    </Box>
                  </>
                ) : (
                  <></>
                )}
                {column.dataIndex !== "operation" ? (
                  <>
                    {column.dataIndex === "storageFrequency" ? (
                      <Typography
                        style={{ lineHeight: "24px" }}
                        sx={{
                          textAlign: "left",
                          alignContent: "end",
                          color: "var(--PrimaryText)",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {handleStorageFrequency(data[column.dataIndex])}
                      </Typography>
                    ) : (
                      <Typography
                        style={{ lineHeight: "24px" }}
                        sx={{
                          textAlign: "left",
                          alignContent: "end",
                          color: "var(--PrimaryText)",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {column.dataIndex === "groupName" &&
                        data[column.dataIndex].charAt(0) === "_"
                          ? handlename(data[column.dataIndex])
                          : data[column.dataIndex]}
                      </Typography>
                    )}
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                      }}
                    >
                      <CustomTooltip
                        title={"Edit"}
                        offset={[30, -20]}
                        placement={"right-end"}
                      >
                        <Button
                          id={index}
                          value={"0"}
                          onClick={handleEdit}
                          disabled={
                            props.disabled === 2 || props.disabled === 1
                              ? true
                              : false
                          }
                          sx={{
                            width: "40px",
                            "& .MuiButtonBase-root.MuiButton-root": {
                              width: "40px",
                            },
                            padding: 0,
                          }}
                          style={{
                            fontSize: "12px",
                            height: "20px",
                            width: "20px",
                            minWidth: "20px",
                            boxSizing: "border-box",
                            fontWeight: 400,
                            alignSelf: "center",
                            marginLeft: "0px",
                            marginRight: "0",
                            marginTop: "0px",
                          }}
                        >
                          <LK_Edit
                            color={
                              props.disabled === 2 || props.disabled === 1
                                ? theme === "light"
                                  ? "#C1C1C1"
                                  : "#3C3C3C"
                                : "var(--LK_BrandBlue)"
                            }
                            width={"20px"}
                            height={"20px"}
                          />
                        </Button>
                      </CustomTooltip>
                    </Box>
                  </>
                )}
              </Box>
            ))}
          </Box>
          <Divider
            variant="middle"
            style={{
              margin: "0px 0px 0px 0px",
              width: "100%",
              background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
            }}
          />
        </>
      ))}
    </>
  );
}

function GroupForm(props) {
  const { theme } = useContext(ThemeContext);
  const [isEdit, setisEdit] = React.useState(-1);
  const [info, setInfo] = React.useState({
    id: "",
    groupName: "",
    description: "",
    storageFrequency: [],
  });
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [groupDetails, setGroupDetails] = React.useState(1);
  const [storageFrequencyDetails, setStorageFrequencyDetails] =
    React.useState(1);
  const [disableButtons, setDisableButtons] = React.useState(0);
  const [frequencyList, setFrequencyList] = React.useState([
    ...info.storageFrequency,
  ]);
  const [frequency, setFrequency] = React.useState({
    Frequency: "",
    AggreationFunction: [],
  });
  const [aggreationFunction, setAggreationFunction] = React.useState({
    FunctionName: "",
    Dependency: "",
    DependencyFunction: "",
  });
  const [freqoptions, setFreqOptions] = React.useState([]);
  const [funcoptions, setFuncOptions] = React.useState([]);
  const [dialog, setDialog] = React.useState([0, ""]);

  const grpcolumns = [
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      required: true,
      width: "23%",
    },
    {
      title: "Aggregation Function",
      dataIndex: "aggreationFunction",
      key: "aggreationFunction",
      width: "55%",
      required: false,
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: "22%",
      key: "operation",
      required: false,
    },
  ];

  useEffect(() => {
    if (props.info !== null) {
      setInfo({
        id: props.info.id,
        groupName: props.info.groupName,
        description: props.info.description,
        storageFrequency: props.info.storageFrequency,
      });
      setFrequencyList([...props.info.storageFrequency]);
    }
  }, [props.info]);

  useEffect(() => {
    if (props.freq && props.freq.length > 0) {
      let options = [];
      props.freq.forEach((item) => {
        // if(item.FrequencyName !=="Raw"){
        options = [...options, item.FrequencyName];
        // }
      });
      setFreqOptions([...options]);
    }
  }, [props.freq]);

  useEffect(() => {
    if (props.func && props.func.length > 0) {
      let options = [];
      props.func.forEach((item) => {
        // if(item.FrequencyName !=="Raw"){
        options = [...options, item.FunctionName];
        // }
      });
      setFuncOptions([...options]);
    }
  }, [props.func]);

  function handleCloseAddForm() {
    props.handleCloseAddForm();
  }

  function validatename(name) {
    let same = 0;
    if (name === "" || name === undefined || name === null) {
      same = 1;
    } else {
      for (let i = 0; i < props.data.length; i++) {
        let newname = props.data[i];
        if (props.data[i].charAt(0) === "_") {
          newname = props.data[i].substring(1);
        }
        if (newname === name) {
          same = 1;
        }
      }
    }
    return same;
  }

  function handleSaveAddForm() {
    if (info.groupName === "") {
      setRequired(1);
    } else {
      // if(info.id===""){
      if (validatename(info.groupName) === 1 && info.id === "") {
        setRequired(2);
      } else {
        info.storageFrequency = [...frequencyList];
        props.handleSaveAddForm(info);
        if (info.id === "") {
          setInfo({
            id: "",
            groupName: "",
            description: "",
            storageFrequency: [],
          });
        }
      }
      // }
      // else{
      //     props.handleSaveAddForm(info);
      //     setInfo({id:"",groupName:"",description:"",storageFrequency:[]});
      // }
    }
  }

  function handleChange(value, e) {
    const temp = { ...info };
    temp[e.currentTarget.id] = value;
    setInfo(temp);
  }

  function handleFrequency(value) {
    const freq = props.freq.filter((item) => item.FrequencyName === value);
    const ifanydependency = handleDependencyOptions(
      frequencyList,
      freq[0].AggFrequency,
    );
    if (ifanydependency.length > 0) {
      setFrequency({
        Frequency: freq[0].AggFrequency,
        AggreationFunction: [...frequency.AggreationFunction],
      });
    } else {
      setFrequency({
        Frequency: "",
        AggreationFunction: [...frequency.AggreationFunction],
      });
      setDialog([1, freq[0].AggFrequency]);
    }
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleAddFrequency() {
    setisEdit(frequencyList.length);
    setDisableButtons(1);
    setFrequencyList([
      ...frequencyList,
      {
        Frequency: frequency.Frequency,
        AggreationFunction: [...frequency.AggreationFunction],
      },
    ]);
    setFrequency({
      Frequency: "",
      AggreationFunction: [{ ...aggreationFunction }],
    });
  }

  function handleDeleteFrequency(e) {
    let temp = [...frequencyList];
    temp = temp.filter(
      (_item, index) => index.toString() !== e.currentTarget.id,
    );
    setFrequencyList([...temp]);
  }

  function handleEdit(e) {
    setDisableButtons(1);
    setisEdit(parseInt(e.currentTarget.id, 10));
    // setFrequencyList([...info.storageFrequency])
    setFrequency({ ...frequencyList[e.currentTarget.id] });
  }

  function handleAddAggregationFunction() {
    setFrequency({
      Frequency: frequency.Frequency,
      AggreationFunction: [...frequency.AggreationFunction, aggreationFunction],
    });
  }

  function handleRequired() {
    let req = 0;
    if (frequency.AggreationFunction.length !== 0) {
      for (let i = 0; i < frequency.AggreationFunction.length; i++) {
        if (
          frequency.AggreationFunction[i].FunctionName === "" ||
          frequency.AggreationFunction[i].Dependency ===
            "" /*|| frequency.AggreationFunction[i].DependencyFunction===""*/
        ) {
          req = 1;
          break;
        }
      }
    } else {
      req = 1;
    }
    return req;
  }

  function handleFrequencySave() {
    const req = handleRequired();
    if (frequency.Frequency !== "" && req === 0) {
      let temp = [...frequencyList];
      temp[isEdit] = frequency;
      let sortedFreq = [];
      for (let i = 0; i < props.freq.length; i++) {
        for (let j = 0; j < temp.length; j++) {
          if (props.freq[i].AggFrequency === temp[j].Frequency) {
            sortedFreq = [...sortedFreq, temp[j]];
          }
        }
      }
      setFrequencyList([...sortedFreq]);
      setFrequency({ Frequency: "", AggreationFunction: [] });
      setisEdit(-1);
      setDisableButtons(0);
    } else {
      setRequired(1);
    }
  }

  function handleFrequencyCancel(e) {
    if (
      frequencyList[isEdit].Frequency === "" ||
      frequencyList[isEdit].AggreationFunction.length === 0
    ) {
      let temp = [...frequencyList];
      temp = temp.filter(
        (item, index) => index.toString() !== e.currentTarget.id,
      );
      setFrequencyList([...temp]);
    }
    setFrequency({ Frequency: "", AggreationFunction: [] });
    setisEdit(-1);
    setDisableButtons(0);
  }

  function handleDeleteAggregationFunction(e) {
    let temp = [...frequency.AggreationFunction];
    temp = temp.filter(
      (item, index) => index.toString() !== e.currentTarget.id,
    );
    setFrequency({
      Frequency: frequency.Frequency,
      AggreationFunction: [...temp],
    });
  }

  function handleFunctionChange(val, e) {
    let temp = frequency.AggreationFunction.map((obj) => ({ ...obj })); //[...frequency.AggreationFunction]
    const func = props.func.filter((f) => f.FunctionName === val);
    temp[e.target.name].FunctionName = func[0].Function;
    if (temp[e.target.name].Dependency === "RAW") {
      temp[e.target.name].DependencyFunction = func[0].Function;
    }
    setFrequency({
      Frequency: frequency.Frequency,
      AggreationFunction: [...temp],
    });
  }

  function handleAggregationFunctions(data) {
    let names = [];
    data.forEach((item) => {
      names = [...names, handleFunctionName(item.FunctionName)];
    });
    return names.join(", ");
  }

  function handleDisableFrequency() {
    let freq = [];
    frequencyList.forEach((item) => {
      let freqd = props.freq.filter((f) => f.AggFrequency === item.Frequency);
      if (freqd.length > 0) {
        freq = [...freq, freqd[0].FrequencyName];
      }
    });
    return freq;
  }

  function handleDisableFunction(data) {
    let func = [];
    data.forEach((item) => {
      func = [...func, handleFunctionName(item.FunctionName)];
    });
    return func;
  }

  function handleDisableDependencyFunction(dep, data) {
    let func = [];
    if (dep !== "RAW") {
      // let depfunc = props.freq.filter(f => f.Dependency === dep)
      data.forEach((item) => {
        func = [...func, handleFunctionName(item.DependencyFunction)];
      });
    }
    return func;
  }

  function handleDependencyOptions(data, freqselected) {
    let options = [];
    const alloweddependency = props.freq.filter(
      (item) => item.AggFrequency === freqselected,
    );
    //
    if (alloweddependency.length > 0) {
      //     alloweddependency[0].DirectDependenciesOptions.forEach((item,index) => {
      //         if(item==='RAW'){
      //             options = [...options, item];
      //         }else{
      //             data.forEach((d) => {
      //                 if(d.Frequency === item){
      //                     options = [...options, d];
      //                 }
      //             });
      //         }
      //     });
      // }else{
      alloweddependency[0].DirectDependenciesOptions.forEach((item, index) => {
        if (item === "RAW") {
          options = [...options, "Raw"];
        } else {
          // data.map((d,i) => {
          // let fname = props.freq.filter(item => item.AggFrequency === d.Frequency);
          for (let i = 0; i < data.length; i++) {
            if (data[i].Frequency === item) {
              options = [...options, handleFrequencyName(data[i].Frequency)];
            }
          }
          // });
        }
      });
    }
    return options;
  }

  function handleFrequencyName(frequency) {
    let f = "";
    if (frequency === "RAW") {
      f = "Raw";
    } else {
      let freq = props.freq.filter((item) => item.AggFrequency === frequency);
      if (freq.length > 0) {
        f = freq[0].FrequencyName;
      }
    }
    return f;
  }

  function handleDependency(dependency, e) {
    // let freq = props.freq.filter(item => item.FrequencyName === value);
    let temp = frequency.AggreationFunction.map((obj) => ({ ...obj })); //[...frequency.AggreationFunction]
    if (dependency === "Raw") {
      temp[e.target.name].Dependency = "RAW";
    } else {
      const f = props.freq.filter((item) => item.FrequencyName === dependency);
      temp[e.target.name].Dependency = f[0].AggFrequency;
    }
    setFrequency({
      Frequency: frequency.Frequency,
      AggreationFunction: [...temp],
    });
  }

  function handleDependencyFunction(val, e) {
    let temp = frequency.AggreationFunction.map((obj) => ({ ...obj })); //[...frequency.AggreationFunction]
    // if(val==='NA'){
    //     temp[e.target.name].DependencyFunction = 'NA';
    // }else{
    const func = props.func.filter((f) => f.FunctionName === val);
    temp[e.target.name].DependencyFunction = func[0].Function;
    // }
    setFrequency({
      Frequency: frequency.Frequency,
      AggreationFunction: [...temp],
    });
  }

  function handleFunctionName(func) {
    const functionName = props.func.filter((item) => item.Function === func);
    if (functionName.length > 0) {
      return functionName[0].FunctionName;
    } else {
      return "";
    }
  }

  function handlename(name) {
    const newname = name.substring(1);
    return newname;
  }

  function handleDependiesAvailable(freq) {
    let f = [];
    let availabledependency = props.freq.filter(
      (item) => item.AggFrequency === freq,
    );
    if (availabledependency.length !== 0) {
      let dep = availabledependency[0].DirectDependenciesOptions.map((i) => {
        f.push(handleFrequencyName(i));
      });
      return f.join(", ");
    } else {
      return f.join(", ");
    }
  }

  function handleDependencyFunctionOptions(
    frequencyList,
    dependency,
    functionName,
  ) {
    let options = [];
    if (dependency === "RAW") {
      options = [handleFunctionName(functionName)];
    } else {
      let func = frequencyList.filter((freq) => freq.Frequency === dependency);
      if (func.length > 0 && func[0].AggreationFunction.length > 0) {
        func[0].AggreationFunction.forEach((item) => {
          options = [...options, handleFunctionName(item.FunctionName)];
        });
      } else {
        // options = ["NA"]
      }
    }
    return options;
  }

  return (
    <Box
      sx={{
        padding: "0px",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          padding: "0px",
          width: "100%",
          height: "7%",
          boxSizing: "border-box",
          display: "flex",
          gap: "8px",
        }}
      >
        {saveStatus !== 0 ? (
          <CustomToast
            openToast={saveStatus !== 0}
            /*type={ saveStatus===1?"Success":"Error"}*/ autoHideDuration={
              10000
            }
            toastText={saveStatus === 1 ? "Saved Successfully!" : "Save Failed"}
            onClose={handleToastClose}
          />
        ) : (
          <></>
        )}
        <Box
          sx={{ display: "flex", gap: "8px", width: "100%", height: "100%" }}
        >
          <Box sx={{ flexGrow: 1 }}></Box>
          <CustomDialogBox
            dialogTitle={"Required fields not filled"}
            dialogText={"Required fields to must be filled"}
            openDialog={required === 1}
            handleCloseDialog={() => setRequired(0)}
            handleConfirmDialog={() => setRequired(0)}
            confirmText={"OK"}
            cancelText={"Cancel"}
            type={"Warning"}
          />
          <CustomDialogBox
            dialogTitle={"Group name already in use"}
            dialogText={"This group name is already in use"}
            openDialog={required === 2}
            handleCloseDialog={() => setRequired(0)}
            handleConfirmDialog={() => setRequired(0)}
            confirmText={"OK"}
            cancelText={"Cancel"}
            type={"Warning"}
          />
          <CustomDialogBox
            dialogTitle={"No Dependent Frequency available"}
            dialogText={
              "Please create any of the dependent frequency first. Dependent frequencies: " +
              handleDependiesAvailable(dialog[1])
            }
            openDialog={dialog[0] == 1}
            handleCloseDialog={() => setDialog([0, ""])}
            handleConfirmDialog={() => setDialog([0, ""])}
            confirmText={"OK"}
            cancelText={"Cancel"}
            type={"Warning"}
          />
          <CustomCancelButton
            onClick={handleCloseAddForm}
            disabled={disableButtons !== 0 ? true : false}
            buttonText={"Cancel"}
          ></CustomCancelButton>
          <CustomButton
            /*id={deviceInfo.id}*/ disabled={
              disableButtons !== 0 || info.groupName.charAt(0) === "_"
                ? true
                : false
            }
            onClick={handleSaveAddForm}
            buttonText={"Save"}
            width={"12px"}
          />
        </Box>
      </Box>
      <Box
        sx={{
          boxSizing: "border-box",
          padding: "8px",
          background: "var(--PrimaryBackground)",
          height: "calc(93%)",
          marginBottom: "0px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "7%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#008CD7",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {info.id === ""
              ? "Group"
              : info.groupName.charAt(0) === "_"
                ? handlename(info.groupName)
                : info.groupName}
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "93%", overflow: "auto" }}>
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop:
                "20px" /*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/,
            }}
          >
            Group Details{" "}
            <Button
              onClick={() => {
                groupDetails === 1 ? setGroupDetails(0) : setGroupDetails(1);
              }}
            >
              {groupDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {groupDetails === 1 ? (
            <Box
              style={{ overflow: "auto" }}
              sx={{
                minHeight: "18%",
                display: "flex",
                gap: "0px",
                flexWrap: "wrap",
                padding: "4px 4px 12px 4px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Group Name
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTextField
                  id={"groupName"}
                  onChange={handleChange}
                  disabled={info.id !== "" ? true : false}
                  defaultValue={
                    info.groupName.charAt(0) === "_"
                      ? handlename(info.groupName)
                      : info.groupName
                  }
                  maxLength={250}
                  width={1297}
                  permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_]*$"}
                  errorText={"Only alphanumeric characters are allowed"}
                />
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    width: "224px",
                  }}
                >
                  Group Description
                </Typography>
                <CustomTextField
                  id={"description"}
                  onChange={handleChange}
                  disabled={info.groupName.charAt(0) === "_" ? true : false}
                  defaultValue={info.description}
                  maxLength={250}
                  width={1297}
                />
              </Box>
            </Box>
          ) : (
            <></>
          )}
          <Typography
            className="config-heading"
            style={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#008CD7",
              padding: "4px",
              marginTop:
                "20px" /*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/,
            }}
          >
            Storage Frequency{" "}
            <Button
              onClick={() => {
                storageFrequencyDetails === 1
                  ? setStorageFrequencyDetails(0)
                  : setStorageFrequencyDetails(1);
              }}
            >
              {storageFrequencyDetails === 1 ? (
                <ExpandLessOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              ) : (
                <ExpandMoreOutlinedIcon
                  style={{
                    width: "28px",
                    height: "28px",
                    fontWeight: 700,
                    color: "#008CD7",
                  }}
                />
              )}
            </Button>
          </Typography>
          {storageFrequencyDetails === 1 ? (
            <Box
              style={{
                height: groupDetails === 1 ? "90.5%" : "90.5%",
                width: "100%",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              sx={{
                padding: "8px 8px",
                backgroundColor: theme === "dark" ? "#3C3C3C40" : "#FFFFFF80",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                  flexDirection: "row",
                  boxSizing: "border-box",
                  height: "28px",
                }}
              >
                <CustomTooltip
                  title={"Add"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleAddFrequency}
                    disabled={
                      disableButtons !== 0 || info.groupName.charAt(0) === "_"
                        ? true
                        : false
                    }
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      width: "28px",
                      minWidth: "28px",
                      fontWeight: 400,
                      alignSelf: "center",
                    }}
                  >
                    <LK_Add
                      color={
                        disableButtons !== 0 || info.groupName.charAt(0) === "_"
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                {/* <CustomTooltip title={"Delete"} offset={[30,-20]} placement={'right-end'}>
                                        <Button onClick={handleDeleteFrequency} disabled={disableButtons!==0?true:false} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'36px',width:'36px',minWidth:'28px',fontWeight: 400,alignSelf:"center"}}><LK_Delete color={disableButtons!==0?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"36px"} height={"36px"}/></Button>
                                </CustomTooltip> */}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "calc(100% - 28px)",
                  backgroundColor: "none",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "none",
                    boxSizing: "border-box",
                    padding: "8px",
                    textAlign: "start",
                    alignItems: "start",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {grpcolumns.map((column, index) => (
                    <>
                      <Box
                        sx={{
                          height: "100%",
                          width: column.width ? column.width : "auto",
                          backgroundColor: "none",
                          boxSizing: "border-box",
                          padding: "0px 8px",
                          alignContent: "center",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                        {/* {index===0?
                                            <Box sx={{height:'100%',boxSizing:"border-box",padding:"0px 8px 0px 0px", marginTop:"-4px", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                <CustomCheckbox checked={deleteArr.length===frequencyList.length?true:false} disabled={disableButtons!==0 && disableButtons!==1?true:false} onChange={handleCheckALL} width={15} height={15}/>
                                            </Box>
                                        :<></>
                                        } */}
                        <Typography
                          sx={{
                            textAlign: "left",
                            color: "var(--PrimaryText)",
                            alignContent: "end",
                          }}
                        >
                          {column.title}
                        </Typography>
                      </Box>
                    </>
                  ))}
                </Box>
                <Divider
                  variant="middle"
                  style={{
                    margin: "0px 2px 0px 2px",
                    background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                  }}
                  sx={{ width: "100%" }}
                />
                {/* <Box sx={{height:'8%',width:'100%',backgroundColor:"none",boxSizing:"border-box",padding:"8px",textAlign:"start",alignItems:"start",display:'flex',flexDirection:'row'}}>
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"33.33%"}}>Frequency</Typography>
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"33.33%"}}>Aggreagation Function</Typography>
                                    <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"33.33%"}}>Operation</Typography>
                                </Box> */}
                <Box
                  sx={{
                    height: "86%",
                    width: "100%",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                  }}
                >
                  {frequencyList.map((data, index) => (
                    <>
                      {/* <Box sx={{height:'8%',width:'100%',backgroundColor:"none",boxSizing:"border-box",padding:"8px",textAlign:"start",alignItems:"start",display:'flex',flexDirection:'row'}}>
                                                <Box sx={{width:"33.33%"}}>
                                                    <CustomDropDown id={'Frequency'} options={['Raw','1MIN']} onChange={handleChange} disabled={false} defaultValue={frequency.Frequency} width={264}></CustomDropDown>                                             
                                                </Box>
                                                <Box sx={{width:"33.33%"}}>
                                                    <CustomDropDown id={'Frequency1'} options={[]} onChange={handleChange} disabled={false} defaultValue={frequency.Frequency} width={264}></CustomDropDown>                                             
                                                </Box>
                                                <Box sx={{width:"33.33%"}}>
                                                </Box>
                                            </Box> */}
                      <Box
                        sx={{
                          /*height:'40px',*/ width: "100%",
                          backgroundColor: "none",
                          boxSizing: "border-box",
                          alignContent: "center",
                          padding: "0px 8px",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        {grpcolumns.map((column, cindex) => (
                          <Box
                            sx={{
                              height: "100%",
                              maxHeight: "196px",
                              width: column.width ? column.width : "auto",
                              backgroundColor: "none",
                              boxSizing: "border-box",
                              padding: "8px",
                              alignContent: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            {/* {cindex===0?
                                                            <>
                                                                <Box sx={{height:'100%',boxSizing:"border-box", padding:"8px",paddingLeft:0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                                    <CustomCheckbox id={data.id} checked={(props.checkList.includes(data.id))?true:false} disabled={(props.disabled===99 && props.disabled===1) || (data['groupName'].charAt(0)==='_')?true:false} onChange={handleCheck} width={15} height={15}/>
                                                                </Box>
                                                            </>
                                                            :<></>
                                                        } */}
                            {column.dataIndex !== "operation" ? (
                              <>
                                {isEdit === index ? (
                                  <>
                                    {column.dataIndex ===
                                    "aggreationFunction" ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          width: "100%",
                                          height: "100%",
                                          boxSizing: "border-box",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "8px",
                                            boxSizing: "border-box",
                                            justifyContent: "start",
                                            justifyItems: "start",
                                            alignItems: "left",
                                            alignContent: "center",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          <Typography
                                            style={{ lineHeight: "32px" }}
                                            sx={{
                                              textAlign: "left",
                                              alignContent: "end",
                                              color: "var(--PrimaryText)",
                                              width: "28%",
                                            }}
                                          >
                                            Function
                                          </Typography>
                                          <Typography
                                            style={{ lineHeight: "32px" }}
                                            sx={{
                                              textAlign: "left",
                                              alignContent: "end",
                                              color: "var(--PrimaryText)",
                                              width: "28%",
                                            }}
                                          >
                                            Dependency
                                          </Typography>
                                          <Typography
                                            style={{ lineHeight: "32px" }}
                                            sx={{
                                              textAlign: "left",
                                              alignContent: "end",
                                              color: "var(--PrimaryText)",
                                              width: "28%",
                                            }}
                                          >
                                            Dependency Function
                                          </Typography>
                                          <CustomTooltip
                                            title={"Add"}
                                            offset={[30, -20]}
                                            placement={"right-end"}
                                          >
                                            <Button
                                              onClick={
                                                handleAddAggregationFunction
                                              }
                                              disabled={
                                                frequency.Frequency === "" ||
                                                info.groupName.charAt(0) === "_"
                                                  ? true
                                                  : false
                                              }
                                              sx={{
                                                width: "40px",
                                                "& .MuiButtonBase-root.MuiButton-root":
                                                  { width: "40px" },
                                                padding: 0,
                                              }}
                                              style={{
                                                fontSize: "12px",
                                                height: "28px",
                                                width: "28px",
                                                minWidth: "28px",
                                                fontWeight: 400,
                                                alignSelf: "center",
                                              }}
                                            >
                                              <LK_Add
                                                color={
                                                  (disableButtons !== 0 &&
                                                    disableButtons !== 1) ||
                                                  frequency.Frequency === "" ||
                                                  info.groupName.charAt(0) ===
                                                    "_"
                                                    ? theme === "light"
                                                      ? "#C1C1C1"
                                                      : "#3C3C3C"
                                                    : "var(--LK_BrandBlue)"
                                                }
                                                width={"28px"}
                                                height={"28px"}
                                              />
                                            </Button>
                                          </CustomTooltip>
                                        </Box>
                                        <Box
                                          sx={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            height: "100%",
                                            overflow: "auto",
                                            boxSizing: "border-box",
                                          }}
                                        >
                                          {frequency.AggreationFunction.map(
                                            (func, findex) => (
                                              <Box
                                                sx={{
                                                  width: "100%",
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  gap: "8px",
                                                  height: "100%",
                                                  boxSizing: "border-box",
                                                }}
                                              >
                                                {/* <Typography style={{ lineHeight: "24px" }} sx={{textAlign:'left',alignContent:'end', color:'var(--PrimaryText)',width:'40%',}}>Function</Typography>        */}
                                                <Box
                                                  sx={{
                                                    width: "28%",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "start",
                                                    justifyItems: "start",
                                                  }}
                                                >
                                                  <CustomDropDown
                                                    name={findex.toString()}
                                                    options={funcoptions}
                                                    onChange={
                                                      handleFunctionChange
                                                    }
                                                    disabled={
                                                      frequency.Frequency === ""
                                                        ? true
                                                        : false
                                                    }
                                                    defaultValue={handleFunctionName(
                                                      func.FunctionName,
                                                    )}
                                                    disabledOptions={handleDisableFunction(
                                                      frequency.AggreationFunction,
                                                    )}
                                                    width={"189px"}
                                                  ></CustomDropDown>
                                                  <span
                                                    style={{
                                                      color: "red",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    *
                                                  </span>
                                                </Box>
                                                {/* <Typography style={{ lineHeight: "24px" }} sx={{textAlign:'left',alignContent:'end', color:'var(--PrimaryText)',width:'40%',}}>Dependency</Typography>    */}
                                                <Box
                                                  sx={{
                                                    width: "28%",
                                                    alignItems: "start",
                                                    alignContent: "start",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "start",
                                                    justifyItems: "start",
                                                  }}
                                                >
                                                  <CustomDropDown
                                                    name={findex.toString()}
                                                    options={handleDependencyOptions(
                                                      frequencyList,
                                                      frequency.Frequency,
                                                    )}
                                                    onChange={handleDependency}
                                                    disabled={
                                                      frequency.Frequency ===
                                                        "" ||
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].FunctionName === ""
                                                        ? true
                                                        : false
                                                    }
                                                    defaultValue={handleFrequencyName(
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].Dependency,
                                                    )}
                                                    width={"189px"}
                                                  ></CustomDropDown>
                                                  <span
                                                    style={{
                                                      color: "red",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    *
                                                  </span>
                                                </Box>
                                                <Box
                                                  sx={{
                                                    width: "28%",
                                                    alignItems: "start",
                                                    alignContent: "start",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "start",
                                                    justifyItems: "start",
                                                  }}
                                                >
                                                  <CustomDropDown
                                                    name={findex.toString()}
                                                    options={handleDependencyFunctionOptions(
                                                      frequencyList,
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].Dependency,
                                                      func.FunctionName,
                                                    )}
                                                    onChange={
                                                      handleDependencyFunction
                                                    }
                                                    disabled={
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].Dependency === "" ||
                                                      frequency.Frequency === ""
                                                        ? true
                                                        : false
                                                    }
                                                    defaultValue={handleFunctionName(
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].DependencyFunction,
                                                    )}
                                                    disabledOptions={handleDisableDependencyFunction(
                                                      frequency
                                                        .AggreationFunction[
                                                        findex
                                                      ].Dependency,
                                                      frequency.AggreationFunction,
                                                    )}
                                                    width={"189px"}
                                                  ></CustomDropDown>
                                                  <span
                                                    style={{
                                                      color: "red",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    *
                                                  </span>
                                                </Box>
                                                <CustomTooltip
                                                  title={"Delete"}
                                                  offset={[30, -20]}
                                                  placement={"right-end"}
                                                >
                                                  <Button
                                                    id={findex}
                                                    onClick={
                                                      handleDeleteAggregationFunction
                                                    }
                                                    disabled={
                                                      frequency.Frequency ===
                                                        "" ||
                                                      info.groupName.charAt(
                                                        0,
                                                      ) === "_"
                                                        ? true
                                                        : false
                                                    }
                                                    sx={{
                                                      width: "40px",
                                                      "& .MuiButtonBase-root.MuiButton-root":
                                                        { width: "40px" },
                                                      padding: 0,
                                                    }}
                                                    style={{
                                                      fontSize: "12px",
                                                      height: "36px",
                                                      width: "36px",
                                                      minWidth: "28px",
                                                      fontWeight: 400,
                                                      alignSelf: "center",
                                                      marginLeft: "-4px",
                                                    }}
                                                  >
                                                    <LK_Delete
                                                      color={
                                                        (disableButtons === 0 ||
                                                          disableButtons ===
                                                            1) &&
                                                        frequency.Frequency !==
                                                          "" &&
                                                        info.groupName.charAt(
                                                          0,
                                                        ) !== "_"
                                                          ? "var(--LK_BrandBlue)"
                                                          : theme === "light"
                                                            ? "#C1C1C1"
                                                            : "#3C3C3C"
                                                      }
                                                      width={"36px"}
                                                      height={"36px"}
                                                    />
                                                  </Button>
                                                </CustomTooltip>
                                              </Box>
                                            ),
                                          )}
                                        </Box>
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: column.width
                                            ? column.width
                                            : "auto",
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <Box>
                                          <CustomDropDown
                                            id={"frequency"}
                                            options={freqoptions}
                                            onChange={handleFrequency}
                                            disabled={false}
                                            disabledOptions={handleDisableFrequency()}
                                            defaultValue={handleFrequencyName(
                                              frequency.Frequency,
                                            )}
                                            width={264}
                                          ></CustomDropDown>
                                        </Box>
                                        {column.required === true ? (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                      </Box>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {column.dataIndex ===
                                    "aggreationFunction" ? (
                                      <Typography
                                        style={{ lineHeight: "24px" }}
                                        sx={{
                                          textAlign: "left",
                                          alignContent: "end",
                                          color: "var(--PrimaryText)",
                                        }}
                                      >
                                        {handleAggregationFunctions(
                                          data.AggreationFunction,
                                        )}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        style={{ lineHeight: "24px" }}
                                        sx={{
                                          textAlign: "left",
                                          alignContent: "end",
                                          color: "var(--PrimaryText)",
                                        }}
                                      >
                                        {handleFrequencyName(data.Frequency)}
                                      </Typography>
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {isEdit === index ? (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "20px",
                                      }}
                                    >
                                      <Button
                                        id={index}
                                        onClick={handleFrequencySave}
                                        disabled={
                                          info.groupName.charAt(0) === "_"
                                            ? true
                                            : false
                                        }
                                        sx={{
                                          width: "40px",
                                          "& .MuiButtonBase-root.MuiButton-root":
                                            { width: "40px" },
                                          padding: 0,
                                          minWidth: "16px",
                                        }}
                                        style={{
                                          fontSize: "12px",
                                          boxSizing: "border-box",
                                          fontWeight: 400,
                                          alignSelf: "center",
                                          justifyContent: "start",
                                        }}
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        id={index}
                                        onClick={handleFrequencyCancel}
                                        disabled={false}
                                        sx={{
                                          width: "40px",
                                          "& .MuiButtonBase-root.MuiButton-root":
                                            { width: "40px" },
                                          padding: 0,
                                          minWidth: "16px",
                                        }}
                                        style={{
                                          fontSize: "12px",
                                          boxSizing: "border-box",
                                          fontWeight: 400,
                                          alignSelf: "center",
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    </Box>
                                  </>
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "20px",
                                      }}
                                    >
                                      <CustomTooltip
                                        title={"Edit"}
                                        offset={[30, -20]}
                                        placement={"right-end"}
                                      >
                                        <Button
                                          id={index}
                                          onClick={handleEdit}
                                          disabled={
                                            disableButtons !== 0 ? true : false
                                          }
                                          sx={{
                                            width: "40px",
                                            "& .MuiButtonBase-root.MuiButton-root":
                                              { width: "40px" },
                                            padding: 0,
                                          }}
                                          style={{
                                            fontSize: "12px",
                                            height: "20px",
                                            width: "20px",
                                            minWidth: "20px",
                                            boxSizing: "border-box",
                                            fontWeight: 400,
                                            alignSelf: "center",
                                            marginLeft: "0px",
                                            marginRight: "0",
                                            marginTop: "0px",
                                          }}
                                        >
                                          <LK_Edit
                                            color={
                                              disableButtons !== 0
                                                ? theme === "light"
                                                  ? "#C1C1C1"
                                                  : "#3C3C3C"
                                                : "var(--LK_BrandBlue)"
                                            }
                                            width={"20px"}
                                            height={"20px"}
                                          />
                                        </Button>
                                      </CustomTooltip>
                                      <CustomTooltip
                                        title={"Delete"}
                                        offset={[30, -20]}
                                        placement={"right-end"}
                                      >
                                        <Button
                                          id={index}
                                          onClick={handleDeleteFrequency}
                                          disabled={
                                            disableButtons !== 0 ||
                                            info.groupName.charAt(0) === "_"
                                              ? true
                                              : false
                                          }
                                          sx={{
                                            width: "40px",
                                            "& .MuiButtonBase-root.MuiButton-root":
                                              { width: "40px" },
                                            padding: 0,
                                          }}
                                          style={{
                                            fontSize: "12px",
                                            height: "30px",
                                            width: "30px",
                                            minWidth: "28px",
                                            fontWeight: 400,
                                            alignSelf: "center",
                                          }}
                                        >
                                          <LK_Delete
                                            color={
                                              disableButtons !== 0 ||
                                              info.groupName.charAt(0) === "_"
                                                ? theme === "light"
                                                  ? "#C1C1C1"
                                                  : "#3C3C3C"
                                                : "var(--LK_BrandBlue)"
                                            }
                                            width={"30px"}
                                            height={"30px"}
                                          />
                                        </Button>
                                      </CustomTooltip>
                                    </Box>
                                  </>
                                )}
                              </>
                            )}
                          </Box>
                        ))}
                      </Box>
                      <Divider
                        variant="middle"
                        style={{
                          margin: "0px",
                          width: "100%",
                          background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                        }}
                      />
                    </>
                  ))}
                </Box>
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default function Storage() {
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [deleteSuccess, setDeleteSuccess] = React.useState(0);
  const [openGroupForm, setOpenGroupForm] = React.useState(0);
  const [editIndex, setEditIndex] = React.useState(-1);
  const [search, setSearch] = useState({ searchText: "" });
  const [ifsearching, setifSearching] = useState(0);
  const [searchList, setsearchList] = React.useState([]);
  const [tableData, setTableData] = React.useState([]);
  const [checkAll, setCheckAll] = React.useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = React.useState(0);
  const [deleteArr, setDeleteArr] = React.useState([]);
  const [frequency, setFrequency] = React.useState([]);
  const [functions, setFunction] = React.useState([]);
  const [saveConfirmation, setSaveConfirmation] = React.useState([0, {}]);
  const [deletionMessage, setDeletionMessage] = React.useState([0, []]);
  const [deviceList, setDeviceList] = React.useState([]);
  const [loading, setLoading] = useState(1);
  const [disableButtons, setDisableButtons] = useState(99);
  //for disableButtons = 0, all buttons are enabled
  //for disableButtons = 99, all buttons are disabled
  //for disableButtons = 1, only delete button  and select all and close is enabled  ///search  what about search while deleting??
  //for disableButtons = 2, only save form and close form is enabled ?

  const { theme } = useContext(ThemeContext);

  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "name",
      required: true,
      width: "27%",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "30%",
      required: false,
    },
    {
      title: "Frequency",
      dataIndex: "storageFrequency",
      key: "frequency",
      width: "25%",
      required: false,
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: "18%",
      key: "operation",
      required: false,
    },
  ];

  useEffect(() => {
    setDisableButtons(0);
    getFrequencyAndFunctionList(getFrequencyAndFunctionListcallback);
    getStorageGroups(getStorageGroupscallback);
    getdevicelist(getdevicelistcallback);
    setLoading(1);
  }, []);

  useEffect(() => {
    if (ifsearching === 1) {
      handleSearchClick();
    }
  }, [tableData]);

  function getdevicelistcallback(res) {
    let data = [];
    res.map((_val, index) => {
      data = [...data, [res[index].Name, res[index].DeviceID]];
    });
    setDeviceList(data);
    setLoading(0);
    setDisableButtons(0);
  }

  function getFrequencyAndFunctionListcallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setFrequency(res.data.data.freq);
      setFunction(res.data.data.func);
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
    setDisableButtons(0);
  }

  function getStorageGroupscallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      let temp = [];
      res.data.data.map((val) => {
        let obj = {};
        obj.id = val.GroupID;
        obj.groupName = val.GroupName;
        obj.description = val.Description;
        obj.storageFrequency = val.FrequencyList;
        temp.push(obj);
      });
      setTableData(temp);
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
    setDisableButtons(0);
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleDeleteToastClose() {
    setDeleteSuccess(0);
  }

  function handleAddGroup() {
    setOpenGroupForm(1);
  }

  function handleCheckALL(selected) {
    if (selected) {
      // const temp = [...deleteArr];
      const temp = [];
      for (let j = 0; j < tableData.length; j++) {
        // const ifpresent = deleteArr.includes(tableData[j].id);
        const ifstd = tableData[j].groupName.charAt(0) === "_" ? true : false;
        if (!ifstd) {
          //if(!ifpresent && !ifstd){
          temp.push(tableData[j].id);
        }
      }
      setDeleteArr([...temp]);
      setCheckAll(true);
    } else {
      setDeleteArr([]);
      setCheckAll(false);
    }
  }

  function handleCheck(selected, e) {
    if (selected) {
      setDeleteArr([...deleteArr, e.currentTarget.id]);
      let count = tableData.filter(
        (item) => item.groupName.charAt(0) === "_",
      ).length;
      if (deleteArr.length + 1 === tableData.length - count) {
        setCheckAll(true);
      }
    } else {
      const newDeleteArr = deleteArr.filter(
        (item) => item !== e.currentTarget.id,
      );
      setDeleteArr(newDeleteArr);
      if (checkAll === true) {
        setCheckAll(false);
      }
    }
  }

  function handleCloseAddForm() {
    setOpenGroupForm(0);
    setEditIndex(-1);
  }

  function handleEdit(id) {
    if (ifsearching === 1) {
      let index = tableData.findIndex((item) => item.id === searchList[id].id);
      setEditIndex(index);
    } else {
      setEditIndex(id);
    }
    setOpenGroupForm(1);
  }

  function handleDelete() {
    if (deleteArr.length > 0) {
      setDeleteConfirmation(1);
    } else {
      setDeleteConfirmation(2);
    }
  }

  function handleDeleteCancel() {
    setDeleteConfirmation(0);
    setDeleteArr([]);
    setCheckAll(false);
  }

  function handleDeleteConfirmed() {
    deleteStorageGroup(deleteArr, deleteStorageGroupcallback);
    setLoading(1);
  }

  function deleteStorageGroupcallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      if (res.data.message === "success") {
        let temp = [...tableData];
        for (let i = 0; i < deleteArr.length; i++) {
          temp = temp.filter((item) => item.id !== deleteArr[i]);
        }
        setTableData(temp);
        setDeleteSuccess(1);
      } else {
        setDeletionMessage([1, res.data.data]);
      }
    } else if (res.status === 500) {
      // pop for error
      setDeleteSuccess(2);
    }
    setDeleteConfirmation(0);
    setDeleteArr([]);
    setCheckAll(false);
    setLoading(0);
  }

  function handleSaveAddFormClick(groupInfo) {
    if (groupInfo.id === "") {
      handleSaveAddForm(groupInfo);
    } else {
      setSaveConfirmation([1, groupInfo]);
    }
  }

  function handleSaveConfirmationCancel() {
    setSaveConfirmation([0, {}]);
  }

  function handleSaveAddForm(groupInfo) {
    saveStorageGroup(groupInfo, saveStorageGroupcallback);
    setOpenGroupForm(0);
    setEditIndex(-1);
    setSaveConfirmation([0, {}]);
  }

  function saveStorageGroupcallback(res, grpdata) {
    if (res.status === 200) {
      if (res.data.type === "success") {
        if (grpdata.id === "") {
          grpdata.id = res.data.data;
          setTableData([...tableData, grpdata]);
        } else {
          const updatedData = tableData.map((item) =>
            item.id === grpdata.id ? grpdata : item,
          );
          setTableData(updatedData);
        }
        setSaveStatus(1);
      }
    } else if (res.status === 500) {
      // pop for error
      setSaveStatus(0);
    }
  }

  function handleDeviceNames() {
    let data = [];
    for (let i = 0; i < deletionMessage[1].length; i++) {
      for (let j = 0; j < deviceList.length; j++) {
        if (deletionMessage[1][i] === deviceList[j][1]) {
          data = [...data, deviceList[j][0]];
        }
      }
    }
    return data.join(", ");
  }

  function handleSearchClick() {
    let data = [];
    if (search.searchText.trim() !== "") {
      for (let i = 0; i < tableData.length; i++) {
        if (
          tableData[i].groupName
            .toLowerCase()
            .includes(search.searchText.trim().toLowerCase()) ||
          (tableData[i].description &&
            tableData[i].description
              .toLowerCase()
              .includes(search.searchText.trim().toLowerCase()))
        ) {
          data = [...data, tableData[i]];
        }
      }
    }
    setifSearching(1);
    setsearchList(data);
  }

  function handleSearchText(val) {
    setSearch({ searchText: val });
  }

  function handleSearchCancel() {
    setSearch({ searchText: "" });
    setifSearching(0);
    setsearchList([]);
  }

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
    >
      {saveStatus != 0 ? (
        <CustomToast
          openToast={saveStatus != 0}
          type={saveStatus == 1 ? "Success" : "Error"}
          autoHideDuration={10000}
          toastText={saveStatus == 1 ? "Saved Successfully!" : "Save Failed"}
          onClose={handleToastClose}
        />
      ) : (
        <></>
      )}
      {deleteSuccess !== 0 ? (
        <CustomToast
          openToast={deleteSuccess !== 0}
          type={deleteSuccess == 1 ? "Success" : "Error"}
          toastText={
            deleteSuccess == 1 ? "Deleted Successfully!" : "Delete Failed"
          }
          onClose={handleDeleteToastClose}
        />
      ) : (
        <></>
      )}
      <CustomDialogBox
        dialogTitle={"Delete Confirmation"}
        dialogText={
          "Are you sure you want to delete " +
          deleteArr.length +
          " Storage groups. \nNote: This will delete the group and its related configuration set in existing Parameter"
        }
        openDialog={deleteConfirmation === 1}
        handleCloseDialog={handleDeleteCancel}
        handleConfirmDialog={handleDeleteConfirmed}
        confirmText={"OK"}
        cancelText={"Cancel"}
        type={"Warning"}
      />
      <CustomDialogBox
        dialogTitle={"Delete Confirmation"}
        dialogText={"Please select group for deletion"}
        openDialog={deleteConfirmation === 2}
        handleCloseDialog={handleDeleteCancel}
        handleConfirmDialog={() => {
          setDeleteConfirmation(0);
        }}
        confirmText={"OK"}
        cancelText={"Cancel"}
        type={"Warning"}
      />
      <CustomDialogBox
        dialogTitle={"Save Confirmation"}
        dialogText={
          "Modifying this group will update the configuration of all existing tags that use it. Do you want to save and continue?"
        }
        openDialog={saveConfirmation[0] === 1}
        handleCloseDialog={handleSaveConfirmationCancel}
        handleConfirmDialog={() => {
          handleSaveAddForm(saveConfirmation[1]);
        }}
        confirmText={"OK"}
        cancelText={"Cancel"}
        type={"Warning"}
      />
      <CustomDialogBox
        dialogTitle={"Selected Groups are in use."}
        dialogText={
          "The groups are in use in tags of following devices: " +
          handleDeviceNames() +
          "."
        }
        openDialog={deletionMessage[0] === 1}
        handleCloseDialog={() => {
          setDeletionMessage([0, []]);
        }}
        handleConfirmDialog={() => {
          setDeletionMessage([0, []]);
        }}
        confirmText={"OK"}
        cancelText={"Cancel"}
        type={"Warning"}
      />
      {loading === 1 ? (
        <>
          <Box
            sx={{
              gap: "8px",
              boxSizing: "border-box",
              height: "calc(100%)",
              width: "100%",
              overflow: "auto",
              alignContent: "center",
            }}
          >
            <img
              src={LK_Loading}
              alt="loading..."
              style={{ height: "15%", width: "auto", alignSelf: "center" }}
            />
          </Box>
        </>
      ) : (
        <>
          {openGroupForm === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  boxSizing: "border-box",
                  padding: "0px",
                  height: "7%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Box sx={{ flexGrow: 1, height: "100%" }}></Box>
                <CustomTooltip
                  title={"Add"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleAddGroup}
                    disabled={disableButtons !== 0 ? true : false}
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "28px",
                      width: "28px",
                      minWidth: "28px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Add
                      color={
                        disableButtons !== 0
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                <CustomTooltip
                  title={"Delete"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleDelete}
                    disabled={disableButtons !== 0 ? true : false}
                    sx={{
                      width: "40px",
                      "& .MuiButtonBase-root.MuiButton-root": { width: "40px" },
                      padding: 0,
                    }}
                    style={{
                      fontSize: "12px",
                      height: "36px",
                      width: "36px",
                      minWidth: "28px",
                      fontWeight: 400,
                      alignSelf: "center",
                      marginTop: "-8px",
                    }}
                  >
                    <LK_Delete
                      color={
                        disableButtons !== 0
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"36px"}
                      height={"36px"}
                    />
                  </Button>
                </CustomTooltip>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "14%",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    marginTop: "-4px",
                    alignSelf: "center",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  <CustomTextField
                    id={"negative-feedback"}
                    onChange={handleSearchText}
                    disabled={
                      disableButtons !== 0 && disableButtons !== 1
                        ? true
                        : false
                    }
                    defaultValue={ifsearching === 0 ? "" : search.searchText}
                    placeholder={"search"}
                    width={180}
                  />
                  <CustomTooltip
                    title={"Search"}
                    offset={[30, -20]}
                    placement={"right-end"}
                  >
                    <Button
                      onClick={handleSearchClick}
                      style={{
                        fontSize: "12px",
                        width: "40px",
                        minWidth: "40px",
                        fontWeight: 400,
                        color: "var(--Searchtext_muted)",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        justifySelf: "right",
                        cursor: "pointer",
                        textTransform: "none",
                        marginLeft: "0px",
                        padding: 0,
                      }}
                    >
                      <LK_Search
                        color={
                          disableButtons !== 0 && disableButtons !== 1
                            ? theme === "light"
                              ? "#C1C1C1"
                              : "#3C3C3C"
                            : "var(--LK_BrandBlue)"
                        }
                        width={"28px"}
                        height={"28px"}
                      />
                    </Button>
                  </CustomTooltip>
                  {ifsearching === 1 ? (
                    <Button
                      onClick={handleSearchCancel}
                      style={{
                        fontSize: "12px",
                        width: "34px",
                        minWidth: "34px",
                        fontWeight: 400,
                        color: "var(--Searchtext_muted)",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        justifySelf: "right",
                        cursor: "pointer",
                        textTransform: "none",
                        marginLeft: "-8px",
                        padding: 0,
                      }}
                    >
                      <LK_Close
                        color={
                          disableButtons !== 0 && disableButtons !== 1
                            ? theme === "light"
                              ? "#C1C1C1"
                              : "#3C3C3C"
                            : "var(--LK_BrandBlue)"
                        }
                        width={"24px"}
                        height={"24px"}
                      />
                    </Button>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  boxSizing: "border-box",
                  padding: "8px",
                  background: "var(--PrimaryBackground)",
                  minHeight: "93%",
                  marginBottom: "0px",
                }}
              >
                <Box
                  sx={{
                    boxSizing: "border-box",
                    padding: "8px",
                    background: "var(--SecondaryBackground)",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      boxSizing: "border-box",
                      background: "var(--SecondaryBackground)",
                      height: "8%",
                    }}
                  >
                    {columns.map((column, index) => (
                      <>
                        <Box
                          sx={{
                            height: "100%",
                            width: column.width ? column.width : "auto",
                            backgroundColor: "none",
                            boxSizing: "border-box",
                            padding: "8px",
                            alignContent: "center",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                        >
                          {index === 0 ? (
                            <Box
                              sx={{
                                height: "100%",
                                boxSizing: "border-box",
                                padding: "0px 8px 0px 0px",
                                marginTop: "-4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CustomCheckbox
                                checked={checkAll}
                                disabled={
                                  disableButtons !== 0 && disableButtons !== 1
                                    ? true
                                    : false
                                }
                                onChange={handleCheckALL}
                                width={15}
                                height={15}
                              />
                            </Box>
                          ) : (
                            <></>
                          )}
                          <Typography
                            sx={{
                              textAlign: "left",
                              color: "var(--PrimaryText)",
                              alignContent: "end",
                            }}
                          >
                            {column.title}
                          </Typography>
                        </Box>
                      </>
                    ))}
                  </Box>
                  <Divider
                    variant="middle"
                    style={{
                      margin: "0px 2px 0px 2px",
                      background: theme === "dark" ? "#3C3C3C" : "#EFEFEF",
                      height: "0.5px",
                    }}
                  />
                  <Box
                    sx={{
                      height: "calc(92% - 0.5px)",
                      width: "100%",
                      backgroundColor: "none",
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "auto",
                      alignItems: "center",
                    }}
                  >
                    <TableRow
                      width={"100%"}
                      data={ifsearching === 1 ? searchList : tableData}
                      columns={columns}
                      disabled={disableButtons}
                      handleCheck={handleCheck}
                      checkList={deleteArr}
                      freq={frequency}
                      handleEdit={handleEdit}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <GroupForm
              handleCloseAddForm={handleCloseAddForm}
              handleSaveAddForm={handleSaveAddFormClick}
              data={tableData.map((item) => item.groupName)}
              info={editIndex !== -1 ? tableData[editIndex] : null}
              freq={frequency}
              func={functions}
            />
          )}
        </>
      )}
    </Box>
  );
}
